import { render, staticRenderFns } from "./mylogging.vue?vue&type=template&id=4520660a&scoped=true&"
import script from "./mylogging.vue?vue&type=script&lang=js&"
export * from "./mylogging.vue?vue&type=script&lang=js&"
import style0 from "./mylogging.vue?vue&type=style&index=0&id=4520660a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520660a",
  null
  
)

export default component.exports